var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAttachmentHr(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 12,
    viewBox: "0 0 20 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.5 11.5C3.96667 11.5 2.66667 10.9667 1.6 9.9C0.533333 8.83333 0 7.53333 0 6C0 4.46667 0.533333 3.16667 1.6 2.1C2.66667 1.03333 3.96667 0.5 5.5 0.5H16C17.1 0.5 18.0417 0.891667 18.825 1.675C19.6083 2.45833 20 3.4 20 4.5C20 5.6 19.6083 6.54167 18.825 7.325C18.0417 8.10833 17.1 8.5 16 8.5H6.5C5.8 8.5 5.20833 8.25833 4.725 7.775C4.24167 7.29167 4 6.7 4 6C4 5.3 4.24167 4.70833 4.725 4.225C5.20833 3.74167 5.8 3.5 6.5 3.5H15.25C15.4667 3.5 15.646 3.57067 15.788 3.712C15.9293 3.854 16 4.03333 16 4.25C16 4.46667 15.9293 4.64567 15.788 4.787C15.646 4.929 15.4667 5 15.25 5H6.5C6.21667 5 5.97933 5.09567 5.788 5.287C5.596 5.479 5.5 5.71667 5.5 6C5.5 6.28333 5.596 6.52067 5.788 6.712C5.97933 6.904 6.21667 7 6.5 7H16C16.7 7 17.2917 6.75833 17.775 6.275C18.2583 5.79167 18.5 5.2 18.5 4.5C18.5 3.8 18.2583 3.20833 17.775 2.725C17.2917 2.24167 16.7 2 16 2H5.5C4.4 2 3.45833 2.39167 2.675 3.175C1.89167 3.95833 1.5 4.9 1.5 6C1.5 7.1 1.89167 8.04167 2.675 8.825C3.45833 9.60833 4.4 10 5.5 10H15.25C15.4667 10 15.646 10.0707 15.788 10.212C15.9293 10.354 16 10.5333 16 10.75C16 10.9667 15.9293 11.146 15.788 11.288C15.646 11.4293 15.4667 11.5 15.25 11.5H5.5Z",
    fill: "black",
    fillOpacity: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttachmentHr);
export default __webpack_public_path__ + "static/media/AttachmentHr.463c4f441e1752ec6c6b85c9d7450f67.svg";
export { ForwardRef as ReactComponent };